import type { ReactNode } from "react";

/*
 * A caixa de campo — motivo de assinatura 3 do doc 06a §3.6, e o átomo de toda
 * tela de detalhe.
 *
 * "Todo par rótulo/valor renderiza como campo da ficha: micro-caixa-alta em
 * `--texto-2` em cima, valor embaixo, bloco em `--superficie-2` com borda
 * `--fio`."
 *
 * É o vocabulário da ficha de compensação — o documento que o próprio sistema
 * produz — traduzido para superfície escura.
 */
export function CaixaDeCampo({
  rotulo,
  children,
  dados = false,
  className = "",
}: {
  rotulo: string;
  children: ReactNode;
  /** Identificador, dinheiro ou número: IBM Plex Mono com dígitos tabulares. */
  dados?: boolean;
  className?: string;
}) {
  return (
    <div
      className={`rounded-controle border border-fio bg-superficie-2 px-3 py-2 ${className}`}
    >
      <div className="rotulo">{rotulo}</div>
      <div className={`mt-[2px] text-texto ${dados ? "dados" : ""}`}>
        {/*
          Um campo sem valor mostra travessão, e não fica vazio: espaço em branco
          num par rótulo/valor lê como falha de carregamento, e o travessão diz
          "perguntamos, e não há".
        */}
        {children ?? <span className="text-texto-3">—</span>}
      </div>
    </div>
  );
}
